const countries = {
  AR: '54',
  US: '1',
  UY: '598',
  PY: '595',
}

export default countries
